import { useFolderCreationContext } from '@/context/folderCreationContext';
import useClientContext from '@/context/ObjectContext/useClientContext';
import useDealContext from '@/context/ObjectContext/useDealContext';
import { useGetRelationshipCompanyQuery } from '@/features/relationshipCompanies/relationshipCompaniesApi';
import { isClientPreviewRoute } from '@/hooks/usePreviewMode';
import React, { createContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const ObjectContext = createContext({});

export const ObjectContextProvider = ({ children, dealIdOverride = null }) => {
	const params = useParams();
	const location = useLocation();

	const clientContext = useClientContext(dealIdOverride);
	const context = useFolderCreationContext();

	const searchParams = new URLSearchParams(location.search);
	const previewId = searchParams.get('preview');

	const isClientPreview = isClientPreviewRoute(location.pathname) && previewId;
	const dealId = dealIdOverride ?? (isClientPreview ? null : params?.dealId || previewId);

	const dealContext = useDealContext(dealId);
	const relationshipCompanyId = params?.relationshipCompanyId;
	const { currentData: relationshipCompany } = useGetRelationshipCompanyQuery(
		relationshipCompanyId,
		{ skip: !relationshipCompanyId },
	);

	const value = {
		...params,
		...context,
		...clientContext,
		clientId: clientContext.clientId ?? params?.clientId,
		isClientView: Boolean(params?.clientId) || isClientPreview,
		isRelationshipCompanyView: Boolean(relationshipCompanyId),
		...(relationshipCompanyId && relationshipCompany),
		...(dealId && { ...dealContext, dealId }),
	};

	return <ObjectContext.Provider value={value}>{children}</ObjectContext.Provider>;
};
